import { useEffect, useState } from 'react'

/** A white-label brand applied by /crm/brand.js (see docs/white-label.md). */
export interface Brand {
  name: string
  tagline?: string
  logo?: string
  favicon?: string
  accent?: string
  /** Hide Calendar / Book Me for this brand. */
  crmOnly?: boolean
  /** false = no plans or paywall for this brand. */
  billing?: boolean
}

declare global {
  interface Window {
    __HUNTS_BRAND__?: Brand
  }
}

/** The active white-label brand, or null on our own Hunts hosts. */
export function useBrand(): Brand | null {
  const [brand, setBrand] = useState<Brand | null>(() => window.__HUNTS_BRAND__ ?? null)
  useEffect(() => {
    const onBrand = (e: Event) => setBrand((e as CustomEvent<Brand>).detail)
    window.addEventListener('hunts:brand', onBrand)
    return () => window.removeEventListener('hunts:brand', onBrand)
  }, [])
  return brand
}
